import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledShellMerchandisingStepWrapper = styled(Flexbox)`
    ${({theme: {palette}}) => css`
        border: 1px solid ${palette.neutral[200]};
        border-radius: 16px;
    `}
`
